(function () {
  'use strict';

  function parseMoney(value) {
    if (!value) {
      return 0;
    }

    var normalized = String(value).replace(/[^0-9.,-]/g, '').replace(',', '.');
    var amount = parseFloat(normalized);
    return Number.isNaN(amount) ? 0 : amount;
  }

  function formatSavings(value) {
    return 'Save $' + value.toFixed(2);
  }

  function initGallery(section) {
    if (typeof window.Splide !== 'function') {
      return;
    }

    var mainCarousel = section.querySelector('.product-custom__main-carousel');
    var thumbCarousel = section.querySelector('.product-custom__thumbnails');

    if (!mainCarousel || !thumbCarousel || mainCarousel.dataset.splideMounted === 'true') {
      return;
    }

    if (!mainCarousel.querySelector('.splide__slide') || !thumbCarousel.querySelector('.splide__slide')) {
      return;
    }

    var main = new window.Splide(mainCarousel, {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true
    });

    var thumbnails = new window.Splide(thumbCarousel, {
      fixedWidth: 80,
      fixedHeight: 80,
      gap: 8,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        768: {
          fixedWidth: 60,
          fixedHeight: 60
        }
      }
    });

    main.sync(thumbnails);
    thumbnails.mount();
    main.mount();

    mainCarousel.dataset.splideMounted = 'true';
    thumbCarousel.dataset.splideMounted = 'true';
  }

  function initOffers(section) {
    var inputs = section.querySelectorAll('input[name="product-offer"]');
    var valueBar = section.querySelector('.product-custom__value-bar');

    if (!inputs.length || !valueBar) {
      return;
    }

    var original = valueBar.querySelector('[id^="value-original-"]');
    var youPay = valueBar.querySelector('[id^="value-you-pay-"]');
    var saveBadge = valueBar.querySelector('[id^="value-save-"]');

    function updateValueBar(input) {
      var price = input.dataset.price || '';
      var comparePrice = input.dataset.comparePrice || '';
      var valuePrice = input.dataset.value || comparePrice;
      var saved = Math.max(parseMoney(valuePrice) - parseMoney(price), 0);

      if (original) {
        original.textContent = valuePrice || comparePrice || price;
      }

      if (youPay) {
        youPay.textContent = price;
      }

      if (saveBadge) {
        saveBadge.textContent = formatSavings(saved);
      }

      section.querySelectorAll('.offer-card').forEach(function (card) {
        card.classList.remove('offer-card--active');
      });

      var activeCard = input.closest('.offer-card');
      if (activeCard) {
        activeCard.classList.add('offer-card--active');
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateValueBar(input);
      });
    });

    var selected = section.querySelector('input[name="product-offer"]:checked') || inputs[0];
    if (selected) {
      selected.checked = true;
      updateValueBar(selected);
    }
  }

  function initTabs(section) {
    section.querySelectorAll('.product-tab__trigger').forEach(function (button) {
      if (button.dataset.bound === 'true') {
        return;
      }

      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var tab = button.closest('.product-tab');
        var isOpen = tab && tab.classList.contains('is-open');

        section.querySelectorAll('.product-tab').forEach(function (item) {
          item.classList.remove('is-open');
          var trigger = item.querySelector('.product-tab__trigger');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });

        if (!isOpen && tab) {
          tab.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAtc(section) {
    var button = section.querySelector('.product-custom__atc-btn');

    if (!button || button.dataset.bound === 'true') {
      return;
    }

    if (button.dataset.externalUrl) {
      button.dataset.bound = 'true';
      return;
    }

    button.dataset.bound = 'true';
    button.addEventListener('click', function () {
      var selected = section.querySelector('input[name="product-offer"]:checked');
      var variantId = selected && selected.dataset.variantId;

      if (!variantId) {
        window.alert('Please choose an offer before adding to cart.');
        return;
      }

      button.disabled = true;
      button.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          window.location.href = '/cart';
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = button.getAttribute('data-default-label') || 'ADD TO CART →';
          window.alert('Unable to add this offer to cart right now.');
        });
    });

    button.setAttribute('data-default-label', button.textContent);
  }

  function initSection(section) {
    initGallery(section);
    initOffers(section);
    initTabs(section);
    initAtc(section);
  }

  function initAllSections() {
    document.querySelectorAll('.product-custom').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAllSections);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('.product-custom');
    if (section) {
      initSection(section);
    } else {
      initAllSections();
    }
  });
})();
